import { ReactElement } from 'react';
import { cloneElement, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from 'react-transition-group/CSSTransition';
import stylesBack from './back.module.css';
import stylesFront from './front.module.css';

type FlipProps = {
  children: ReactElement;
  disableAnimations?: boolean;
} & Omit<CSSTransitionProps, 'addEndListener'>;

export const Flip = ({
  children,
  timeout = 500,
  disableAnimations,
  ...rest
}: FlipProps) => {
  const nodeRef = useRef(null);

  return (
    <CSSTransition
      nodeRef={nodeRef}
      timeout={disableAnimations ? 0 : timeout}
      unmountOnExit
      {...rest}
    >
      {cloneElement(children, { ref: nodeRef })}
    </CSSTransition>
  );
};

export const FlipFront = (props: FlipProps) => (
  <Flip
    classNames={!props.disableAnimations ? stylesFront : undefined}
    {...props}
  />
);

export const FlipBack = (props: FlipProps) => (
  <Flip
    classNames={!props.disableAnimations ? stylesBack : undefined}
    {...props}
  />
);

Flip.Front = FlipFront;
Flip.Back = FlipBack;
